
import { Vue, Component } from 'vue-property-decorator';
import { isVisibleLineBanner } from '@/lib/functions';

@Component
export default class ButtonLine extends Vue {
  get visibleLineButton(): boolean {
    return isVisibleLineBanner({
      lang: this.$store.getters['auth/lang'],
      group: this.$store.getters['auth/group'],
    });
  }
}
